// extracted by mini-css-extract-plugin
module.exports = {"importTaskHeader":"ProductPriceUpdate_importTaskHeader__2CfQU","importTaskInfo":"ProductPriceUpdate_importTaskInfo__2m22O"};